<!--
 功能名称:千里眼平台(技师)-选择门店
 开发人:梁高权
 创建时间:2021/03/30
 最后修改时间:2021/03/30
-->
<template>
  <div class="store-message-wrap">

    <!-- 搜索框 -->
    <van-search
      v-model="value"
      :show-action="true"
      placeholder="请输入搜索关键词"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>

    <!-- 门店内容 -->
    <div>
      <empty-box v-if="storeList.length==0"></empty-box>
      <ul v-for="(item,index) in storeList" :key="index" class="store-content"  @click="chooseShopItem(item)">
         <li>
            <h4 class="store-name">{{item.shop_name}}</h4>
            <p class="store-address" v-if="!!item.storeAds">地址：{{item.address_detail}}</p>
            <van-icon name="checked" v-if="userStatus.curs_node_id_1==item.node_id" />
          </li>
      </ul>
    </div>

  </div>
</template>

<script>
import table from '@/api/table'
import util from '@/utils/util'
import { Dialog } from 'vant'
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'store-message',
  components: {
    'empty-box':() => import('@/components/empty-box.vue')
  },
  filters: {},
  mixins: [],
  props: {},
  data () {
    return {
      value: '',
      shopList:[],
      storeList:[],
    }
  },
  computed: {...mapState(['userStatus','technician','openid'])},
  watch: {
    value(val) {
      if(!val){
        this.getShopList()
      }
    }
  },
  created () {
    console.log(this.$route.query.to)
  },
  mounted () {
    this.getShopList()
  },
  methods: {
    ...mapMutations(['updateTechnicianPower','updateCursNodeId1']),
    onSearch() {
      // 使用indexof方法实现模糊查询
      this.storeList=util.fuzzyQuery(this.shopList,this.value,'shop_name')
    },
    // 切换门店
    chooseShopItem(item){
        table.changeNodeId({node_id:item.node_id}).then(response=>{
            if(response.data.result){
               if(!this.authDeadline()){ return location.href=location.protocol+'//'+location.host+'/payIndex'+'?key=technician'}
                localStorage.setItem('shopNameTitle',item.shop_name)
                this.updateCursNodeId1(item.node_id)
                this.updateTechnicianPower(response.data.menu)
                // tabBar菜单权限筛选
                let renderBarList=util.navAuthority(this.technician.navTabBar,this.userStatus.technician_power)
                this.$store.commit('updateRenderBarList',renderBarList)
                if(renderBarList.length>0){
                  if(this.$route.query.to){
                    console.log(this.$route.query.to)
                    this.$router.push({name:this.$route.query.to})
                  }else{
                    this.$router.go(-1)//返回上一层
                  }
                }else{
                  Dialog.alert({
                    title: '提示',
                    message: '无权限,请联系管理员',
                  }).then(() => {
                    location.href=location.protocol+'//'+location.host+'/'+'?openid='+this.openid
                    // this.$router.go(-1);//返回上一层
                  })
                }

            }
        })
    },
    // 可用门店列表
	  getShopList(){
	    table.getShopList().then(response=>{
        this.storeList=response.data.list
        this.shopList=response.data.list
        // console.log(this.storeList)
	    })
	  },
    // 期限
    authDeadline(){
      return util.getRestDay(this.userStatus.vip_1)
    }
  }
}
</script>
<style lang="scss" scoped>
  .store-message-wrap {
    padding-top: 2px;
    .store-content{
         position:relative;
         margin:22px;
         padding:28px;
         background:#fff;
         border-radius:10px;
         line-height:1.5;
         .store-name{
             font-size:30px;
             color:#333;
         }
         .store-address{
             font-size:24px;
             color:#999;
         }
         .van-icon-checked{
             position:absolute;
             top:28px;
             right:28px;
             font-size:40px;
             color:#4C1EFF;
         }
     }
    // 搜索框重写
    /deep/ .van-search{
      padding: 17px 23px;
      .van-search__content{
        background:#EDEDED;
        border-radius: 32px;
        .van-cell--borderless{
          padding-left: 20px;
          input{
            background:#EDEDED;
          }
          input::-webkit-input-placeholder {
             /* placeholder颜色  */
             color: #8E8E93;
             /* placeholder字体大小  */
             font-size: 26px
          }
        }
      }
      .van-search__action{
        margin-left:29px;
        margin-right: 10px;
        color: #333;
        font-size: 28px
      }
    }
  }
</style>
